// extracted by mini-css-extract-plugin
export var divider = "_2d-0";
export var dividerText = "_2d-1";